/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type AccountEntity, accountSchema } from '@axiom/domain';
import { ownerUserSchema } from './owner-user';

export const reputationAccountSchema = accountSchema.pick({ "id": true, "name": true }).extend({ "ownerUser": z.lazy(() => ownerUserSchema).nullish() });
export type ReputationAccount = Pick<AccountEntity, "id" | "name"> & z.infer<typeof reputationAccountSchema>;
